import { apiGet, apiPost, apiDelete } from './client';
import type {
  GoldenDatasetSummary, GoldenDatasetDetail, GoldenQuestionDetail,
  CreateDatasetRequest, UpdateDatasetRequest,
  CreateQuestionRequest, UpdateQuestionRequest, SignalCareRole,
} from './types';

export const listDatasets = (role?: SignalCareRole) => {
  const qs = role ? `?role=${role}` : '';
  return apiGet<GoldenDatasetSummary[]>(`/api/datasets${qs}`);
};

export const getDataset = (id: string) => apiGet<GoldenDatasetDetail>(`/api/datasets/${id}`);

export const createDataset = (body: CreateDatasetRequest) =>
  apiPost<GoldenDatasetDetail>('/api/datasets', body);

export const updateDataset = (id: string, body: UpdateDatasetRequest) =>
  apiPost<GoldenDatasetDetail>(`/api/datasets/${id}`, body);

export const deleteDataset = (id: string) =>
  apiDelete<GoldenDatasetDetail>(`/api/datasets/${id}`);

export const addQuestion = (datasetId: string, body: CreateQuestionRequest) =>
  apiPost<GoldenQuestionDetail>(`/api/datasets/${datasetId}/questions`, body);

export const updateQuestion = (datasetId: string, questionId: string, body: UpdateQuestionRequest) =>
  apiPost<GoldenQuestionDetail>(`/api/datasets/${datasetId}/questions/${questionId}`, body);

export const deleteQuestion = (datasetId: string, questionId: string) =>
  apiDelete<string>(`/api/datasets/${datasetId}/questions/${questionId}`);
